module.exports = __webpack_public_path__ + "img/bilibili-winter-view-3-snow.c5bca8d6.c5bca8d6.png";